<template>
    <div class="page">
        <ion-grid class="page-content">
            <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col size="12" class="col-padding">
                            <ion-label class="light-text" v-if="dataTransfer != 'N'">Enter the OTP displayed in the Charger</ion-label>
                            <ion-label class="light-text" v-if="dataTransfer == 'N'">The OTP sent to registered mobile number</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" class="col-padding">
                            <div class="border-line">
                                <ion-col size="12">
                                    <ion-input
                                    size="3"
                                    type="tel"
                                    autofocus="true"
                                    id="otp1"
                                    #otp1
                                    placeholder="*"
                                    required
                                    maxlength="1"
                                    @input="otp1 = $event.target.value"
                                    @keyup="otpController($event, 'otp2')"
                                    ></ion-input>
                                    <ion-input
                                    size="3"
                                    type="tel"
                                    id="otp2"
                                    #otp2
                                    placeholder="*"
                                    required
                                    maxlength="1"
                                    @input="otp2 = $event.target.value"
                                    @keyup="otpController($event, 'otp3')"
                                    ></ion-input>
                                    <ion-input
                                    size="3"
                                    type="tel"
                                    id="otp3"
                                    #otp3
                                    placeholder="*"
                                    required
                                    maxlength="1"
                                    @input="otp3 = $event.target.value"
                                    @keyup="otpController($event, 'otp4')"
                                    ></ion-input>
                                    <ion-input
                                    size="3"
                                    type="tel"
                                    id="otp4"
                                    #otp4
                                    placeholder="*"
                                    required
                                    maxlength="1"
                                    @input="otp4 = $event.target.value"
                                    @keyup="otpController($event, undefined)"
                                    ></ion-input>
                                </ion-col>
                            </div>
                        </ion-col>
                    </ion-row>
                    <!-- Modified by Swide on 2020-12-16 Bug#1 and 10 -->
                    <ion-row v-if="counter != 0" text-center class="row-margin">
                        <ion-col>
                            <ion-label class="primary-text-link" @click="resendOtp">
                            Resend OTP
                            <span v-if="disableotp">( {{counter}} )</span>
                            </ion-label>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSpinner } from "@ionic/vue";

import { EVCStationReservationService } from "../../service/evcstation/reservation.service";
import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'chargingOTPVerify',
    components: {
        IonGrid, IonRow, IonCol, IonLabel, IonInput, IonSpinner
    },
    data() {
        return {
            loaderTab: true,
            counter: 0,
            disableotp: true,
            mobile: "",
            otp: "",
            otp1: "",
            otp2: "",
            otp3: "",
            otp4: "",
            otpInd: false,
            dataTransfer: 'Y'
        }
    },
    mounted() {
        try {
            this.mobile = new LocalStorage().mobile;
            this.dataTransfer = localStorage.getItem("dataTransfer");
            //Modified by Swide on 2020-12-16 Bug#1 and 10 
            //this.startCountdown(30);
            this.setFirstFocus();
            this.loaderTab = false;
        } catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        setFirstFocus() {
            document.getElementById("otp1").setFocus();
        },
        startCountdown(seconds) {
            this.counter = seconds;
            var interval = setInterval(() => {
                this.counter--;

                if (this.counter <= 0) {
                // The code here will run when
                // the timer has reached zero.

                clearInterval(interval);
                this.disableotp = false;
                }
            }, 1000);
        },
        async resendOtp() {
            if (!this.disableotp) {
                try {
                    await new EVCStationReservationService().startChargingReservationByUser(
                        { id: this.$route.params.bookingId },
                        new LocalStorage().user
                    );
                    new ToastUtils().presentToast("OTP resent to your mobile number");
                    this.disableotp = true;
                    this.startCountdown(30);
                } catch (error) {
                    // let serviceError = tryParseServiceError(error);
                    // new AlertUtils().presentAlert(
                    //     serviceError ? serviceError : error
                    // );
                    // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                    let serviceError = migratedTryParseServiceError(error);
                    new ToastUtils().presentToast(serviceError.description);
                }
            }
        },
        async otpController(event, next) {
            try {
                if (event.target.value.length > 0) {
                    if (next) {
                    document.getElementById(next).setFocus();
                    } else {
                        this.otp = this.otp1 + this.otp2 + this.otp3 + this.otp4;
                        if (this.otp.length == 4 && this.otpInd == false) {
                            try {
                                this.loaderTab = true;
                                this.otpInd = true;
                                await new EVCStationReservationService().verifyOtpForStartCharging(
                                this.otp,
                                { id: this.$route.params.bookingId },
                                new LocalStorage().user
                                );
                                localStorage.setItem("verifystart", "true");
                                this.loaderTab = false;
                                new ToastUtils().presentToast("Charging Initiated Successfully");
                                this.$router.go(-1);
                                /*this.$router.push({
                                name: "myReservationView",
                                params: { bookingId: this.$route.params.bookingId },
                                });*/
                            } catch(error) {
                                let serviceError = migratedTryParseServiceError(error);
                                new ToastUtils().presentToast(serviceError.description);
                                this.loaderTab = false;
                                if (serviceError.code != "CH10004") {
                                    this.loaderTab = false;
                                    this.$router.go(-1);
                                } else {
                                    this.otpInd = false;
                                    this.loaderTab = false;
                                    document.getElementById("otp1").value = null;
                                    document.getElementById("otp2").value = null;
                                    document.getElementById("otp3").value = null;
                                    document.getElementById("otp4").value = null;
                                    this.otp1 = null;
                                    this.otp2 = null;
                                    this.otp3 = null;
                                    this.otp4 = null;
                                    document.getElementById("otp1").setFocus();
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(
                //     serviceError ? serviceError : error
                // );
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
                this.loaderTab = false;
                //Modified by Swide on 2020-12-16 Bug#1 and 10 
                if (serviceError.code != "CH10004") {
                    this.loaderTab = false;
                    this.$router.go(-1);
                } else {
                    this.otpInd = false;
                    this.loaderTab = false;
                    document.getElementById("otp1").value = null;
                    document.getElementById("otp2").value = null;
                    document.getElementById("otp3").value = null;
                    document.getElementById("otp4").value = null;
                    this.otp1 = null;
                    this.otp2 = null;
                    this.otp3 = null;
                    this.otp4 = null;
                    document.getElementById("otp1").setFocus();
                }
            }
        },
    },
})
</script>

<style scoped>
ion-input {
  display: inline-block;
  width: 50px;
  height: 48px;
  margin: 1px;
  --background: #ffffff;
  --padding-start: 7px;
  text-align: center;
}
</style>